import { useEffect, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import { useFetchAllBikajiOrdersMutation, useUpdateOrderStatusBikajiMutation, } from "../../../features/tenant/Bikaji/BikajiApi";
import toast from "react-hot-toast";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";
import { useFetchDailyDataMutation, useFetchMonthlyDataMutation } from "../../../features/tenant/Cavin/CavinApi";

const CavinMonthlyData = () => {
  const [tableDataItems, setTableDataItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const initialRequest = {
    limit: 10,
    offset: 0,
    mobile: "",
    user_id: "",
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  };
  const [request, setRequest] = useState(initialRequest);

  const clearFilters = () => {
    let initReq = { ...initialRequest, month: request.month, year: request.year };
    console.log("initReq", initReq);
    setRequest(initReq);
    handleCavinOrdersList(initReq)
  };

  const [
    fetchCavinMonthlyData,
    {
      data: fetchCavinMonthlyDataResponse,
      error: fetchCavinMonthlyDataError,
      isLoading: fetchCavinMonthlyDataLoading,
    },
  ] = useFetchMonthlyDataMutation();

  const handleCavinOrdersList = (orderRequest = request) => {
    fetchCavinMonthlyData({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      body: orderRequest
    });
  };


  useEffect(() => {

    handleCavinOrdersList();

  }, [limit, offset]);

  useEffect(() => {
    if (
      fetchCavinMonthlyDataResponse &&
      fetchCavinMonthlyDataResponse.body
    ) {
      toast.dismiss();
      toast.success(`${fetchCavinMonthlyDataResponse.message}`, {
        id: "fetchCavinMonthlyDataResponse",
      });
      console.log(
        "transactionsData  data",
        fetchCavinMonthlyDataResponse
      );
      const arr = [...fetchCavinMonthlyDataResponse.body.orders];
      setTableDataItems(arr);

      setTotalRows(fetchCavinMonthlyDataResponse &&
        fetchCavinMonthlyDataResponse.body.total_orders ? fetchCavinMonthlyDataResponse.body.total_orders : 0);

    }

    if (fetchCavinMonthlyDataError) {
      console.log(
        "transactionsData error",
        fetchCavinMonthlyDataError
      );
      toast.dismiss();
      toast.error(`${fetchCavinMonthlyDataError.data.message}`, {
        id: "fetchCavinMonthlyDataError",
      });
    }
  }, [
    fetchCavinMonthlyDataResponse,
    fetchCavinMonthlyDataError,
  ]);

  const columns = [
    {
      name: "S.No",
      cell: (row, idx) => offset + Number(idx + 1),
      width: "80px", // keep fixed
    },
    {
      name: "Name",
      selector: (row) => row.name,
      width: "200px",
      wrap: true,
    },
    {
      name: "Mobile",
      selector: (row) => row.mobile,
      width: "150px",
    },
    {
      name: "User ID",
      selector: (row) => row.user_id,
      width: "250px",
    },
    {
      name: "Month-Year",
      selector: (row) => `${row.month}-${row.year}`,
      width: "100px",
    },
    {
      name: "Secondary Actual",
      selector: (row) => Number(row.secondary_actual_value).toLocaleString(),
      width: "150px",
    },
    {
      name: "Secondary Target",
      selector: (row) => Number(row.secondary_target_value).toLocaleString(),
      width: "150px",
    },
    {
      name: "Secondary Achieved",
      selector: (row) => `${row.secondary_achieved}`,
      width: "150px",
    },
    {
      name: "UBO Target",
      selector: (row) => row.ubo_target,
    },
    {
      name: "UBO Actual",
      selector: (row) => row.ubo_actual,
    },
    {
      name: "UBO Achieved",
      selector: (row) => `${row.ubo_achieved}`,
    },
    {
      name: "Points",
      selector: (row) => Number(row.points).toLocaleString(),
    }
  ];


  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Cavin Monthly Orders
            <LinksComponent />
          </div>

          <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">

            <div className="flex  space-x-2 ">
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    Mobile No
                  </label>
                  <input
                    type="search"
                    id="default-search"
                    className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="Mobile..."
                    required
                    value={request.mobile}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return { ...prevState, mobile: newValue };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    User ID
                  </label>
                  <input
                    type="search"
                    id="default-search"
                    className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="User ID..."
                    required
                    value={request.user_id}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return { ...prevState, user_id: newValue };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    Date
                  </label>
                  <input
                    type="month"
                    id="month-picker"
                    className="w-full text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                    value={`${request.year}-${String(request.month).padStart(2, "0")}`}
                    onChange={(e) => {
                      const [year, month] = e.target.value.split("-");
                      setRequest((prevState) => ({
                        ...prevState,
                        month: Number(month),
                        year: Number(year),
                      }));
                    }}
                  />

                </div>
              </div>
              <div className="">
                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                  &nbsp;
                </label>

                <div className="flex flex-row  gap-2 ">
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                      onClick={() => {
                        handleCavinOrdersList();

                      }}
                    >
                      Search
                    </button>
                  </div>
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                      onClick={() => {
                        clearFilters();
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3">
            {fetchCavinMonthlyDataLoading && <CircleLoaderComponent />}
            <div className="p-3 w-full bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                data={tableDataItems}
                totalRows={
                  fetchCavinMonthlyDataResponse &&
                  fetchCavinMonthlyDataResponse?.body?.total_orders
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CavinMonthlyData;
